import React from "react";
import { MDBCard } from "mdb-react-ui-kit";

function EmployeeTraining({ employeeData }) {
  const renderTraining = (courseType) => {
    let td = [];

    for (
      let i = 1;
      i <
      Math.floor(
        Object.keys(employeeData[`employee ${courseType}`]).length / 2
      );
      i++
    ) {
      if (
        employeeData[`employee ${courseType}`][`${courseType} ${i}`] !== "-"
      ) {
        td.push(
          <div
            key={employeeData[`employee ${courseType}`][`${courseType} ${i}`]}
          >
            <hr className="hr hr-blurry" />
            <div className="trainingTableCourseName ">
              {employeeData[`employee ${courseType}`][`${courseType} ${i}`]}
            </div>
            <div className="trainingTableCourseType">
              {
                employeeData[`employee ${courseType}`][
                  `${courseType} type ${i}`
                ]
              }
            </div>
          </div>
        );
      }
    }

    return td;
  };

  return (
    <div>
      <div className="empColumnMain">
        <div className="trainingTableMain">
          <MDBCard
            className="trainingTableCard"
            style={{
              zIndex: "10",
            }}
          >
            <div className="trainingTableTitle">Foundation Level</div>
            <div className="trainingTableContent">
              {renderTraining("fcourse")}
            </div>
          </MDBCard>
        </div>
        <div className="trainingTableMain">
          <MDBCard
            className="trainingTableCard"
            style={{
              zIndex: "9",
            }}
          >
            <div className="trainingTableTitle">Core Level</div>
            <div className="trainingTableContent">
              {renderTraining("ccourse")}
            </div>
          </MDBCard>
        </div>
        <div className="trainingTableMain">
          <MDBCard
            className="trainingTableCard"
            style={{
              zIndex: "8",
            }}
          >
            <div className="trainingTableTitle">Advanced Level</div>
            <div className="trainingTableContent">
              {renderTraining("acourse")}
            </div>
          </MDBCard>
        </div>
      </div>
    </div>
  );
}

export default EmployeeTraining;
